import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause\">\r\n<circle cx=\"10\" cy=\"10.0015\" r=\"10\" fill=\"#FAFAFB\" />\r\n<path d=\"M13.3215 9.44149L9.12167 6.64159C8.63168 6.29161 8.00171 6.64159 8.00171 7.20157V12.8014C8.00171 13.3613 8.63168 13.7113 9.12167 13.3613L13.3215 10.5614C13.6715 10.2815 13.6715 9.72148 13.3215 9.44149Z\" fill=\"#FAAE56\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol